import React from 'react';

import NavBar from '../NewLanding/components/newNavbar';
import Footer from '../NewLanding/components/newFooter';

import { Container, Row, Col } from 'reactstrap';
import DivisionTitle from '../NewLanding/components/divisionTitle';

export default function Privacy() {
  return (
    <>
      <NavBar />

      <Container fluid className='py-5em mt-5em'>
        <Container className='custom-container'>
          <Row>
            <Col lg='12' className='text-center'>
              <DivisionTitle
                title="Privacy Policy"
              />
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className='bg-blue-shade py-5'>
        <Container>
          <Row>
            <Col md={{ size: '10', offset: '1' }} lg={{ size: '8', offset: '2' }} style={{ fontSize: '1.05rem', lineHeight: '1.5' }}>
              <p>
                RentalSearcher LLC, a Delaware limited liability company doing business as SparkAPT ("SparkAPT," "we," "us," or "our"), is committed to protecting your privacy. This Privacy Policy describes how we collect, use, and disclose information when you access or use <a href="https://www.sparkapt.com" rel="noreferrer" target="_blank">www.sparkapt.com</a> and related services (the "Services").
              </p>
              <p>
                By using the Services, you consent to the practices described in this Privacy Policy.
              </p>

              <h3>Information We Collect</h3>
              <p>We may collect the following categories of information:</p>

              <p><u>Personal Information</u></p>
              <ul className='custom-bullets'>
                <li>Name</li>
                <li>Email address</li>
                <li>Mailing address</li>
                <li>Real estate license number</li>
                <li>Payment and billing information</li>
              </ul>

              <p><u>Usage and Technical Data</u></p>
              <ul className='custom-bullets'>
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device information</li>
                <li>Access times and referring URLs</li>
                <li>Interaction with the Services</li>
              </ul>

              <p><u>User-Provided Data</u></p>
              <p>
                Any information you input into the Services, including client data, leads, and property-related information.
              </p>

              <h3>How We Use Information</h3>
              <p>We use information to:</p>
              <ul className='custom-bullets'>
                <li>Provide, operate, and maintain the Services</li>
                <li>Process transactions</li>
                <li>Communicate with you</li>
                <li>Provide customer support</li>
                <li>Improve and enhance the Services</li>
                <li>Monitor usage and prevent misuse</li>
                <li>Comply with legal obligations</li>
              </ul>
              <p>We do not sell your personal information.</p>

              <h3>Data Ownership and Customer Data</h3>
              <p>
                You retain ownership of any data you submit to the Services. We access and process such data solely as necessary to provide, maintain, and improve the Services.
              </p>

              <h3>Data Sharing</h3>
              <p>We may share information:</p>
              <ul className='custom-bullets'>
                <li>With service providers who assist in operating the Services</li>
                <li>To comply with legal obligations</li>
                <li>To protect rights, safety, and security</li>
                <li>In connection with a business transfer (such as a merger or acquisition)</li>
              </ul>
              <p>We do not sell or rent personal information.</p>

              <h3>Third-Party and Aggregated Data</h3>
              <p>
                The Services may include data obtained from third-party sources or aggregated datasets. SparkAPT does not guarantee the accuracy, completeness, or timeliness of such data.
              </p>

              <h3>Cookies and Tracking Technologies</h3>
              <p>We use cookies and similar technologies to:</p>
              <ul className='custom-bullets'>
                <li>Maintain session state</li>
                <li>Improve user experience</li>
                <li>Analyze usage patterns</li>
              </ul>
              <p>You may control cookies through your browser settings.</p>

              <h3>Data Security</h3>
              <p>
                We implement commercially reasonable safeguards to protect your information. However, no system can be guaranteed to be completely secure.
              </p>

              <h3>Data Retention</h3>
              <p>
                We retain personal information for as long as necessary to provide the Services, comply with legal obligations, resolve disputes, and enforce our agreements.
              </p>

              <h3>Your Privacy Rights</h3>
              <p>Depending on your location, you may have rights to:</p>
              <ul className='custom-bullets'>
                <li>Access your personal information</li>
                <li>Request deletion</li>
                <li>Correct inaccurate information</li>
              </ul>
              <p>
                To exercise these rights, contact us at <a href="mailto:data@sparkapt.com">data@sparkapt.com</a>.
              </p>

              <h3>Children's Privacy</h3>
              <p>
                The Services are not intended for users under 13. We do not knowingly collect information from children.
              </p>

              <h3>Email Communications</h3>
              <p>
                You may opt out of marketing emails at any time by using the unsubscribe link in the email or updating your account settings.
              </p>

              <h3>Text Messages</h3>
              <p>
                By providing your phone number, you consent to receive text message notifications related to your use of the Services. These messages are not sent on a recurring or automated marketing basis and are only triggered by specific actions within the platform, such as when a client views or interacts with a property report you have sent. Message frequency will vary based on your activity. Message and data rates may apply. You may opt out at any time through your account settings.
              </p>

              <h3>External Services</h3>
              <p>
                We may use third-party hosting and infrastructure providers to store and process data.
              </p>

              <h3>Changes to This Policy</h3>
              <p>
                We may update this Privacy Policy from time to time. Continued use of the Services constitutes acceptance of the updated policy.
              </p>

              <h3>Contact Us</h3>
              <p>SparkAPT welcomes your questions or comments regarding this Privacy Policy:</p>

              <p>
                RentalSearcher LLC<br />
                11007 N Orange St. 4th Floor Suite #4328<br />
                Wilmington, Delaware 19801
              </p>

              <p>
                Email:<br />
                <a href='mailto:data@sparkapt.com'>data@sparkapt.com</a>
              </p>

              <p>
                Phone:<br />
                <a href='tel:737-900-6175'>737-900-6175</a>
              </p>

              <p>
                <strong>Effective 2026</strong>
              </p>
            </Col>
            <Col md={{ size: '10', offset: '1' }} lg={{ size: '8', offset: '2' }} style={{ fontSize: '1.05rem', lineHeight: '1.5' }}>
              <p>
                <br/>
                By continuing to use SparkAPT.com and agreeing to privacy policy & <a href='/terms-of-service'>terms of service</a>, you acknowledge that you have read, understood, and accepted our privacy policy & terms of service, including this text message opt-in provision.
              </p>
              <p>
                If you have any questions or concerns regarding our text message opt-in policy or any other aspect of our service, please contact our customer support team at <a href="mailto:data@sparkapt.com">data@sparkapt.com</a>.
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
      <Footer />
    </>
  );
}
